import { CpsLoaderKey } from '@cs-cms/types';
import { createContext, useContext } from 'react';

interface ILoaderContext {
  showLoader: (isVisible: boolean, lockKey: CpsLoaderKey) => void;
  clearAllLoaders: () => void;
  isLoading: boolean;
}

export const LoaderContext = createContext<ILoaderContext>({
  showLoader: () => {},
  clearAllLoaders: () => {},
  isLoading: false
});

export const useLoaderContext = () => useContext(LoaderContext);
